import { inject, Injectable } from '@angular/core';
import { isUserLoggedIn, selectIsFirstLoadDone, selectIsPhoneVerificationRequired } from '@app/app.reducer';
import { Store } from '@ngrx/store';
import { combineLatest, map, merge, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalStateManager {
  readonly #store = inject(Store);

  readonly #isVerifyPhoneModalOpen$ = new Subject<boolean>();

  readonly #verifyPhoneModalState = this.setVerifyPhoneModalState$();

  get verifyPhoneModalState$() {
    return this.#verifyPhoneModalState;
  }

  setIsVerifyPhoneModalOpen(isVerifyPhoneModalOpen: boolean) {
    this.#isVerifyPhoneModalOpen$.next(isVerifyPhoneModalOpen);
  }

  private setVerifyPhoneModalState$() {
    const isVerifyPhoneModalOpen$ = this.#isVerifyPhoneModalOpen$.asObservable();

    const openVerifyPhoneModal$ = combineLatest({
      isFirstLoadDone: this.#store.select(selectIsFirstLoadDone),
      isUserLoggedIn: this.#store.select(isUserLoggedIn),
      isPhoneVerificationRequired: this.#store.select(selectIsPhoneVerificationRequired)
    }).pipe(map(({ isUserLoggedIn, isPhoneVerificationRequired }) => isUserLoggedIn && isPhoneVerificationRequired));

    const mapVerifyPhoneModalState = (isVerifyPhoneModalOpen: boolean) => ({ isVerifyPhoneModalOpen });

    return merge(isVerifyPhoneModalOpen$, openVerifyPhoneModal$).pipe(map(mapVerifyPhoneModalState));
  }
}
